// ======================================================================
// File Name       : ContentLinkList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Table } from 'react-bootstrap';
import { DATA_AFFIILIATION_TYPE_TEXT } from '../../constants/ContentConstant';
import * as ICON from '../../constants/IconConstants';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomLink from '../button/CustomLink';
import { CONTENT_LINK_DETAIL } from '../../constants/PathConstants';

const ContentLinkList = ({
  contentLinkInfo,
  handleSortState,
  goToDetail,
  handleMouseEnter,
  handleMouseLeave,
  recordNum,
  getStartEndData,
}) => {
  const thead = [
    { title: 'コンテンツ識別ID', sortBy: 0},
    { title: 'コンテンツ名', sortBy: 1 , width:'30%'},
    { title: '外部', sortBy: 2, width:'5%'},
    { title: '登録日時', sortBy: 8},
    { title: '登録者', sortBy: null}, // Step 9.0.0
    { title: '操作', sortBy: null, width:'100'},
  ];
  const linkList =
    contentLinkInfo &&
    contentLinkInfo.linkContentList &&
    contentLinkInfo.linkContentList.map((contentLink, index) => {
      const link = CONTENT_LINK_DETAIL.replace(':id', contentLink.contentSecernId);
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
          <td>
            <div> {contentLink.contentSecernId} </div>
          </td>
          <td>{contentLink.contentName}</td>
          <td>{getItemBoxName(DATA_AFFIILIATION_TYPE_TEXT, contentLink.dataAffiliationType)}</td>
          <td>{parseDateForDetail(contentLink.createdAt)}</td>
          {/* Step 9.0.0 START */}
          <td>{contentLink.createdUserName}</td>
          {/* Step 9.0.0 END */}
          <td className='text-center'>
            <CustomLink
              className="margin-right-7 link-detail-edit"
              to={link}
              text="詳細"
            />
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Table striped hover>
        <thead>
          <ReduxFormPaging type='tableHead' data={thead} name='linkSortType' handleSortState={handleSortState} />
        </thead>
        <tbody>{linkList}</tbody>
      </Table>
      <Col sm={12} className='d-flex justify-content-center'>
        <ReduxFormPaging type='paging' name='startPosition' recordNum={recordNum} getStartEndData={getStartEndData} />
      </Col>
    </div>
  );
};

export default ContentLinkList;
